import type { RouteRecordRaw, RouteRecordSingleView } from 'vue-router'

import PATHS from '@/router/paths'
import { AntecipeAffiliatesViewer } from '@/router/permissionsGroupByRouter'

import { AFFILIATE_PAGES } from './labels'
import type { AffiliatePage } from './labels'

export const AFFILIATE_PAGE_SEGMENT: Record<AffiliatePage, string> = {
  overview: 'visao-geral',
  packages: 'pacotes',
  payout: 'repasse',
  units: 'unidades'
}

/** `/afiliado/<tela>` para o afiliado; `/gestao/afiliados/:id/<tela>` no "ver como". */
export const affiliatePortalPath = (page: AffiliatePage, affiliateId?: number | null): string =>
  affiliateId
    ? `${PATHS.ANTECIPE_AFFILIATES}/${affiliateId}/${AFFILIATE_PAGE_SEGMENT[page]}`
    : `${PATHS.AFFILIATE_ROOT}/${AFFILIATE_PAGE_SEGMENT[page]}`

const PAGE_COMPONENTS: Record<AffiliatePage, RouteRecordSingleView['component']> = {
  overview: () => import('./pages/Overview/Index.vue'),
  packages: () => import('./pages/Packages/Index.vue'),
  payout: () => import('./pages/Payout/Index.vue'),
  units: () => import('./pages/Units/Index.vue')
}

/** Só entram no router com VUE_APP_ENABLED_ANTECIPE_AFFILIATE (ver src/router/index.ts). */
export const affiliateRoutes: RouteRecordRaw[] = [
  { path: PATHS.AFFILIATE_ROOT, redirect: PATHS.AFFILIATE_OVERVIEW },
  ...AFFILIATE_PAGES.map(
    (page): RouteRecordRaw => ({
      path: affiliatePortalPath(page),
      name: `afiliado-${AFFILIATE_PAGE_SEGMENT[page]}`,
      component: PAGE_COMPONENTS[page],
      meta: { layout: 'affiliate', requiresAffiliateAuth: true, affiliatePage: page }
    })
  ),
  {
    path: PATHS.ANTECIPE_AFFILIATES,
    name: 'gestao-afiliados',
    component: () => import('@/modules/company/AntecipeAffiliates/Index.vue'),
    meta: {
      requiresCompanyUserAuth: true,
      authorizations: [...AntecipeAffiliatesViewer],
      // Tela de backoffice: nunca destino automático do fallback de acesso negado.
      excludeFromAccessFallback: true
    }
  },
  {
    path: `${PATHS.ANTECIPE_AFFILIATES}/:affiliateId(\\d+)`,
    redirect: (to) => affiliatePortalPath('overview', Number(to.params.affiliateId))
  },
  ...AFFILIATE_PAGES.map(
    (page): RouteRecordRaw => ({
      path: `${PATHS.ANTECIPE_AFFILIATES}/:affiliateId(\\d+)/${AFFILIATE_PAGE_SEGMENT[page]}`,
      name: `gestao-afiliado-${AFFILIATE_PAGE_SEGMENT[page]}`,
      component: PAGE_COMPONENTS[page],
      meta: {
        layout: 'affiliate',
        requiresCompanyUserAuth: true,
        authorizations: [...AntecipeAffiliatesViewer],
        affiliatePage: page,
        affiliateImpersonation: true
      }
    })
  )
]
